"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DashboardTypes_1 = require("../DashboardTypes");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BASE_CLASS_NAME = "sort-filter";
var MenuItem;
(function (MenuItem) {
    MenuItem[MenuItem["Edited"] = 0] = "Edited";
    MenuItem[MenuItem["Created"] = 1] = "Created";
    MenuItem[MenuItem["Views"] = 2] = "Views";
    MenuItem[MenuItem["Relevance"] = 3] = "Relevance";
    MenuItem[MenuItem["LastViewed"] = 4] = "LastViewed";
    MenuItem[MenuItem["Name"] = 5] = "Name";
})(MenuItem || (exports.MenuItem = MenuItem = {}));
var SortBySelector = (function (_super) {
    __extends(SortBySelector, _super);
    function SortBySelector(props) {
        var _this = _super.call(this, props) || this;
        _this.isSortBySelectorOpen = false;
        _this.getMenuItemComponent = function (menuAsset) {
            var _a;
            return (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { key: menuAsset.text, onClick: function () { return _this.selectMenuItem(menuAsset); }, icon: menuAsset.icon, selected: menuAsset.type === ((_a = _this.selectedMenuAsset) === null || _a === void 0 ? void 0 : _a.type) }, menuAsset.text));
        };
        _this.handleButtonClick = function () {
            _this.isSortBySelectorOpen = !_this.isSortBySelectorOpen;
        };
        _this.toggleSortDirection = function () {
            var newSortDirection = _this.props.sortDirection === DashboardTypes_1.SortDirection.Ascending ? DashboardTypes_1.SortDirection.Descending : DashboardTypes_1.SortDirection.Ascending;
            _this.props.onSelectMenuItemHandle(_this.selectedMenuAsset.sortBy, newSortDirection);
        };
        _this.selectMenuItem = function (menuAsset) {
            _this.isSortBySelectorOpen = false;
            _this.props.onSelectMenuItemHandle(menuAsset.sortBy, _this.props.sortDirection);
        };
        return _this;
    }
    SortBySelector.prototype.render = function () {
        var _a;
        var _this = this;
        var _b, _c;
        var _d = this.props, onMouseDown = _d.onMouseDown, menuAssets = _d.menuAssets, compactButton = _d.compactButton, className = _d.className, hideText = _d.hideText, _e = _d.sortDirection, sortDirection = _e === void 0 ? DashboardTypes_1.SortDirection.Descending : _e;
        var commonProps = {
            type: kaleidoscope_1.ButtonType.Tertiary,
            onClick: this.handleButtonClick,
            className: (0, classnames_1.default)("".concat(BASE_CLASS_NAME, "__button"), (_a = {},
                _a["".concat(BASE_CLASS_NAME, "__button--active")] = this.isSortBySelectorOpen,
                _a)),
        };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: BASE_CLASS_NAME, onMouseDown: onMouseDown },
                react_1.default.createElement(kaleidoscope_1.OptionMenu, { className: className !== null && className !== void 0 ? className : "sort-filter-option-menu", isOpen: this.isSortBySelectorOpen, onClose: function () {
                        _this.isSortBySelectorOpen = false;
                    }, button: compactButton ? (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ size: kaleidoscope_1.ButtonSize.Medium, icon: this.selectedMenuAsset.icon }, commonProps))) : (react_1.default.createElement(kaleidoscope_1.Button, __assign({ size: kaleidoscope_1.ButtonSize.Small }, commonProps), (_b = this.selectedMenuAsset) === null || _b === void 0 ? void 0 :
                        _b.icon,
                        !hideText && ((_c = this.selectedMenuAsset) === null || _c === void 0 ? void 0 : _c.text))) }, menuAssets.map(function (menuAsset) { return _this.getMenuItemComponent(menuAsset); }))),
            react_1.default.createElement(kaleidoscope_1.IconButton, { icon: sortDirection === DashboardTypes_1.SortDirection.Ascending ? react_1.default.createElement(icons_1.SortAscending, null) : react_1.default.createElement(icons_1.SortDescending, null), size: compactButton ? kaleidoscope_1.ButtonSize.Medium : kaleidoscope_1.ButtonSize.Small, onClick: this.toggleSortDirection })));
    };
    Object.defineProperty(SortBySelector.prototype, "selectedMenuAsset", {
        get: function () {
            var _a = this.props, selectedMenuItem = _a.selectedMenuItem, menuAssets = _a.menuAssets;
            return menuAssets.find(function (asset) { return asset.type === selectedMenuItem; });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SortBySelector.prototype, "isSortBySelectorOpen", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], SortBySelector.prototype, "selectedMenuAsset", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SortBySelector.prototype, "handleButtonClick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SortBySelector.prototype, "toggleSortDirection", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SortBySelector.prototype, "selectMenuItem", void 0);
    SortBySelector = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SortBySelector);
    return SortBySelector;
}(react_1.default.Component));
exports.default = SortBySelector;
